import { render, staticRenderFns } from "./log-list.vue?vue&type=template&id=52e56730&scoped=true"
import script from "./log-list.vue?vue&type=script&lang=js"
export * from "./log-list.vue?vue&type=script&lang=js"
import style0 from "./log-list.vue?vue&type=style&index=0&id=52e56730&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e56730",
  null
  
)

export default component.exports